<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="用户姓名：">
            <el-input v-model="query.userName" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="用户手机号：">
            <el-input v-model="query.userPho" placeholder="请输入手机号" clearable size="small" />
          </el-form-item>
          <!-- <el-form-item label="身份：">
            <el-select v-model="query.isEnable" placeholder="请选择" clearable size="small">
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="关卡名称：">
            <el-input v-model="query.name" placeholder="请输入关卡名称" clearable size="small" />
          </el-form-item>
          <el-form-item label="闯关模式：">
            <el-select v-model="query.type" placeholder="请选择" clearable size="small">
              <el-option label="考试闯关" :value="1"></el-option>
              <el-option label="学习闯关" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="闯关记录" name="3"></el-tab-pane>
          <el-tab-pane label="待审核" name="0"></el-tab-pane>
          <el-tab-pane label="合格" name="1"></el-tab-pane>
          <el-tab-pane label="不合格" name="2"></el-tab-pane>
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" icon="el-icon-plus">导出</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" :key="activeName" v-if="activeName === '3'">
        <el-table-column label="用户信息" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            {{row.realName}}{{row.identity?'('+row.identity+')':''}}<br />{{row.userPho}}
          </template>
        </el-table-column>
        <el-table-column label="关卡名称" prop="name" align="center" />
        <el-table-column label="闯关阶段" prop="stageNum" align="center" />
        <el-table-column label="闯关模式" prop="orderNo" align="center">
          <template slot-scope="{row}">
            {{row.type === 1?'考试闯关':'学习闯关'}}
          </template>
        </el-table-column>
        <el-table-column label="情景练习题目数量" prop="exerciseNum" align="center" />
        <el-table-column label="学习时长" prop="learningDuration" align="center" />
        <el-table-column label="考试分数" prop="examScores" align="center" />
        <el-table-column label="考试时间" prop="createdTime" sortable="custom" align="center" />
      </el-table>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange" :key="activeName" v-else>
        <el-table-column label="用户信息" prop="name" align="center" width="200">
          <template slot-scope="{row}">
            {{row.realName}}{{row.levelName?'('+row.levelName+')':''}}<br />{{row.userPho}}
          </template>
        </el-table-column>
        <el-table-column label="问题内容" prop="courseScenarioExercisePO.questionContent" align="center" show-overflow-tooltip />
        <el-table-column label="图片" prop="" align="center">
          <template slot-scope="{row}">
            <el-image style="width: 50px; height: 50px" v-if="row.courseScenarioExercisePO && row.courseScenarioExercisePO.imgUrl" :src="row.courseScenarioExercisePO.imgUrl" :preview-src-list="[row.courseScenarioExercisePO.imgUrl]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="回答" prop="correctAnswer" align="center" width="320">
          <template slot-scope="{row}">
            <audio :src="row.answerContent" controls></audio>
          </template>
        </el-table-column>
        <el-table-column label="回答时间" prop="createdTime" sortable="custom" align="center" width="200" />
        <el-table-column label="操作" align="center" width="200" fixed="right">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleState(row,1)" v-if="activeName === '0'" v-hasPermi="['course:passRecords:examine']">合格</el-button>
            <el-button type="text" @click="handleState(row,2)" v-if="activeName === '0'" v-hasPermi="['course:passRecords:examine']">不合格</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import courseSubjectBarrierRecordsApi from '@/api/course/courseSubjectBarrierRecords'
import Pagination from '@/components/Pagination'
import courseScenarioAnswerApi from '@/api/course/courseScenarioAnswer'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
        // parentid: 0,
        name: undefined,
        isEnable: undefined,
      },
      selectItems: [],
      activeName: '3',
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleClick() {
      this.doQueryList({ pageNo: 1 })
    },
    handleFilter() {
      this.query = {}
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 选择框变化
     */
    selectionChange(val) {
      this.selectItems = val
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'createdTime': 'createdTimeSortSign',
        'operatedTime': 'operatedTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      let Ins = this.activeName === '3' ? courseSubjectBarrierRecordsApi.fetchList : courseScenarioAnswerApi.fetchList;
      let params = { ... this.query }
      if (this.activeName != '3') {
        params.answerType = 6;
        params.state = +this.activeName
      }
      return Ins(params)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      questionsApi.getImport(formData).then(res => {
        if (res.code === '0') {
          this.$message.success(res.msg || '操作成功')
          this.doQueryList({})
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.$refs.gradeAdd.handleCreate(row)
    },
    /**
     * 打开查看表单
     */
    handleShow(row, type) {
      this.$emit('handleShow', row, type)
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(row) {
      this.$refs.gradeAdd.handleUpdate(row)
    },
    handleDownload() {
      this.$router.push("/export/list?code=ExportBarrierRecords")
    },
    handleState(row, type) {
      if (type === 1) {
        this.$common.confirm('确认合格？').then(() => courseScenarioAnswerApi.audit({ id: row.id, state: type }))
          .then(() => {
            this.$common.showMsg('success', '操作成功')
            return this.doQueryList({ pageNo: 1 })
          })
      } else {
        this.$prompt('确认不合格？', {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入不合格原因",
          // inputErrorMessage: '请输入不合格原因',
          // inputValidator: (value) => {
          //   if (!value) {
          //     return false;
          //   }
          //   return true;
          // }
        }).then(({ value }) => {
          return courseScenarioAnswerApi.audit({ id: row.id, state: type, reason: value });
        }).then(() => {
          this.$common.showMsg('success', '操作成功')
          return this.doQueryList({ pageNo: 1 })
        })
      }
    },
  }
}
</script>
